/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-18T19:58:30.53
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listConDeputeContractBack,
	listConDeputeContractBackInit,
	listConDeputeContractBackByAuthorizations,
	deleteConDeputeContractBack
	
} from '@api/storagemanage/ConDeputeContractBack';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listConDeputeContractBack({
			state
		}) {
			return new Promise((resolve, reject) => {
				listConDeputeContractBack(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listConDeputeContractBackByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listConDeputeContractBackByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listConDeputeContractBackInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listConDeputeContractBackInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteConDeputeContractBack({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteConDeputeContractBack({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
